export default __webpack_public_path__ + "static/media/lac.a0ffac32.jpg";